import Api from '@/services/Api'

export default {

  getPacklists() {
    return Api().get("v2/packlist/");
  },
  getPacklistItems(name) {
    return Api().get(`v2/packlist/${name}`);
  },
  pausePacklistItem(id) {
    return Api().post(`v2/packlist/pause-item/${encodeURIComponent(id)}`);
  },
  resetPacklist(name) {
    return Api().post(`v2/packlist/reset/${encodeURIComponent(name)}`);
  },
  getPacklistItem(orderId) {
    return Api().get(`v2/packlist/items/${encodeURIComponent(orderId)}`);
  },
  getMultiCartOrders(shelf = 'lower') {
    return Api().get(`v2/multicart?shelf=${shelf}`);
  },
  getPacklistMultiCartItems(name) {
    return Api().get(`v2/packlist/multicart/${encodeURIComponent(name)}`);
  },
  findPacklistItem(managedId) {
    return Api().get(`v2/packlist/find/${encodeURIComponent(managedId)}`);
  },
  trackStart(packlistItemId, startTime) {
    return Api().post(`v2/packlist/tracking/start/${packlistItemId}`, {startTime: startTime});
  },
  trackEnd(packlistItemId) {
    return Api().post(`v2/packlist/tracking/end/${packlistItemId}`);
  },
  applyTrash(orderId, items, resetOnly = false) {
    return Api().post(`v2/packlist/trash/${encodeURIComponent(orderId)}?resetOnly=${resetOnly}`, items);
  },
  getPrinters() {
    return Api().get(`v2/packlist/printers/active`);
  },
  getLaserHistory() {
    return Api().get(`v2/laserhistory`);
  },
  getPackHistory() {
    return Api().get(`v2/packhistory`);
  },
  requestMultiCartSlot(orderId, payload){
    return Api().post(`v2/multicart/${encodeURIComponent(orderId)}`, payload);
  },
  putMultiCartItems(orderId, payload){
    return Api().post(`v2/multicart/${encodeURIComponent(orderId)}/place`, payload);
  },
  printMultiCartShelfLabel(orderId, payload){
    return Api().post(`v2/multicart/${encodeURIComponent(orderId)}/print-shelf-label`, payload);
  },

  print(orderId, printerUrl, under3cm) {
    return Api().post(`v2/packlist/print`, {
      orderId: orderId,
      printerUrl: printerUrl,
      under3cm: under3cm
    });
  },

  // MulticartWizard: Print Swiss A4 documents (CN23 + invoices)
  printMulticartSwissDocuments(orderId, a4PrinterUrl) {
    return Api().post(`v2/multicart/${encodeURIComponent(orderId)}/print-swiss-documents`, {
      printerUrl: a4PrinterUrl
    });
  },

  // MulticartWizard: Print shipping label (+ Prime label if applicable)
  printMulticartShippingLabel(orderId, printerUrl, under3cm = false) {
    return Api().post(`v2/multicart/${encodeURIComponent(orderId)}/print-shipping-label`, {
      printerUrl: printerUrl,
      under3cm: under3cm
    });
  },

  getPackStats() {
    return Api().get(`v2/packStats`);
  },

  sendFeedback(orderId, note) {
    return Api().post(`v2/feedback`, {orderId: orderId, note: note});
  },

  getMultiCartShelfStatus() {
    return Api().get('warehouse/multicart/status');
  },

  getMulticartArticleStatus(hashcode) {
    return Api().get(`warehouse/multicart/article/${hashcode}/status`);
  },

  removeMultiCartArticle(hashcode) {
    return Api().delete(`warehouse/multicart/article/${hashcode}`);
  },

  reportMultiCartOrder(orderId, reported = true) {
    return Api().post(`warehouse/multicart/order/${orderId}/report`, { reported });
  },

  unreportMultiCartOrder(orderId) {
    return Api().post(`warehouse/multicart/order/${orderId}/unreport`);
  },

  getOrder(orderId) {
    return Api().get(`mongo/order/${encodeURIComponent(orderId)}`);
  },

  getOrderAttributes(orderId) {
    return Api().get(`mongo/order/${encodeURIComponent(orderId)}/attributes`);
  },

  //Mulicart Wizard
  getNextMulticartOrder(orderId, shelf = 'lower') {
    const params = new URLSearchParams();
    if (orderId) {
      params.append('orderId', orderId);
    }
    params.append('shelf', shelf);
    return Api().get(`v2/multicart/next?${params.toString()}`);
  },

  unlockMulticartShelf(shelf) {
    return Api().post(`v2/multicart/unlock-shelf`, { shelf });
  },

  splitPackage(packagings) {
    return Api().post(`v2/multicart/split-package`, packagings);
  },

  placeMulticartItem(payload) {
    return Api().post(`v2/multicart/confirm`, payload);
  },

  // Smart packaging selection for split packages
  selectPackagingBySkus(skus) {
    return Api().post(`v2/multicart/select-packaging`, { skus });
  },

  getUnconfirmedMulticartItems() {
    return Api().get(`v2/multicart/unconfirmed`);
  },

  // ========================================
  // MULTICART EXTRA SLOTS CRUD
  // ========================================

  // Get all extra slots
  getAllExtraSlots() {
    return Api().get(`packlist/multicart/extra-slots`);
  },

  // Get single extra slot by name
  getExtraSlot(slotName) {
    return Api().get(`packlist/multicart/extra-slots/${encodeURIComponent(slotName)}`);
  },

  // Create new extra slot
  createExtraSlot(slot, allowedTables) {
    return Api().post(`packlist/multicart/extra-slots`, { slot, allowedTables });
  },

  // Update extra slot allowed tables
  updateExtraSlot(slotName, allowedTables) {
    return Api().put(`packlist/multicart/extra-slots/${encodeURIComponent(slotName)}`, { allowedTables });
  },

  // Delete extra slot
  deleteExtraSlot(slotName) {
    return Api().delete(`packlist/multicart/extra-slots/${encodeURIComponent(slotName)}`);
  },

  // Initialize default slots
  initializeDefaultExtraSlots() {
    return Api().post(`packlist/multicart/extra-slots/initialize`);
  },

  // Get available product tables
  getAvailableProductTables() {
    return Api().get(`packlist/multicart/available-tables`);
  },

  // Print label for extra slot
  printExtraSlotLabel(slotName, printerUrl) {
    return Api().post(`packlist/multicart/extra-slots/${encodeURIComponent(slotName)}/print`, { printerUrl });
  },

  // Get unique products for search query
  getSearchQueryProducts() {
    return Api().get('v2/packlist/search/products');
  },

  // Search for orders by product attributes and table
  searchForAttributes(name, table) {
    return Api().post('v2/packlist/search', {
      name: name,
      table: table
    });
  },
}